export default "__VITE_ASSET__JBsU3bi1__"